import { useContext, useEffect, useState, useCallback } from 'react';
import { useFormik } from 'formik';
import { parseDateString } from '../../../../helpers/dateUtils';
import { validarCIF, validarDNI, validarNIE } from '../../../../functions/documentType';
import esAlumnoMenor from '../../../../helpers/alumnoMenor';
import { AuthContext } from '../../../../context/authContext';
import alumnosApiService from '../../../../services/http/alumnosApiService';
import { httpServiceInstanceNode } from '../../../../services/http/httpService';
import matriculacionApiService from '../../../../services/http/matriculacionApiService';
import { getItem, STORAGE_KEYS } from '../../../../services/storage';
import config from '../../../../config';

const normalizeMunicipioForApi = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str
    .replace(/[áäà]/g, 'a')
    .replace(/[éëè]/g, 'e')
    .replace(/[íïì]/g, 'i')
    .replace(/[óöò]/g, 'o')
    .replace(/[úüù]/g, 'u');
};

const s = (val) => (val == null ? '' : val);

const buildInitialValues = (datosPersonales) => ({
  ...datosPersonales,
  cp: s(datosPersonales.cp),
  tipoDocumento: (datosPersonales.tipoDocumento ?? '-1').toString(),
  documento: s(datosPersonales.documento),
  domicilio: s(datosPersonales.domicilio),
  municipio: s(datosPersonales.municipio),
  municipioNacimiento: s(datosPersonales.municipioNacimiento),
  nacionalidad: s(datosPersonales.nacionalidad),
  nss: s(datosPersonales.nss),
  pais: datosPersonales.pais || 'España',
  paisNacimiento: datosPersonales.paisNacimiento || 'España',
  provincia: datosPersonales.provincia || ' ',
  provinciaNacimiento: datosPersonales.provinciaNacimiento || ' ',
  telefono: s(datosPersonales.telefono),
  movil: s(datosPersonales.movil),
  sexo: datosPersonales.sexo ?? 0,
  centro: datosPersonales.centro ?? '',
  conocer: s(datosPersonales.conocer),
  emailPers: s(datosPersonales.emailPers),
  fechaNacimiento:
    datosPersonales.fechaNacimiento && datosPersonales.fechaNacimiento !== ''
      ? parseDateString(datosPersonales.fechaNacimiento, 'dd/MM/yyyy') ||
        new Date(datosPersonales.fechaNacimiento)
      : null,
  lopdSede: datosPersonales.lopdSede === 'Consiento',
  lopdComunicaciones: datosPersonales.lopdComunicaciones === 'Consiento',
  lopdFecha:
    datosPersonales.lopdFecha && datosPersonales.lopdFecha !== ''
      ? parseDateString(datosPersonales.lopdFecha, 'dd/MM/yyyy') ||
        new Date(datosPersonales.lopdFecha)
      : null,
  idAdditio: s(datosPersonales.idAdditio),
  dndconocer: s(datosPersonales.dndconocer),
  idD2L: s(datosPersonales.idD2L),
  idStripe: s(datosPersonales.idStripe),
});

const useDatosPersonales = ({
  datosPersonales,
  missingDataFunction,
  setMenorEdad,
  prevActiveTab,
}) => {
  const { empresaId } = getItem(STORAGE_KEYS.STUDENT) ?? {};
  const { userOU } = useContext(AuthContext);
  const { idCedesca, idCntec, centro } = userOU;

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen((prev) => !prev);
  const [isModalShown, setIsModalShown] = useState(false);
  const [isModalShown2, setIsModalShown2] = useState(false);
  const [isModalShown3, setIsModalShown3] = useState(false);
  const [document, setDocument] = useState('');
  const [country, setCountry] = useState('');
  const [province, setProvince] = useState('');
  const [poblation, setPoblation] = useState('');
  const [formationCenter, setFormationCenter] = useState([]);
  const [poblationFiltered, setPoblationFiltered] = useState('');
  const [poblationBirthFiltered, setPoblationBirthFiltered] = useState('');
  const [cpFiltered, setCPFiltered] = useState('');
  const [cp, setCP] = useState('');
  const [raw, setRaw] = useState('');
  const [url, setUrl] = useState('');
  const [fidelitationList, setFidelitationList] = useState([]);

  const validate = (values) => {
    const errors = {};
    if (!values.nombre) {
      errors.nombre = 'Obligatorio';
      missingDataFunction(true);
    } else if (!/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.nombre.trim())) {
      errors.nombre = 'Nombre incorrecto';
      missingDataFunction(true);
    }
    if (!values.apellidos) {
      errors.apellidos = 'Obligatorio';
      missingDataFunction(true);
    } else if (!/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.apellidos.trim())) {
      errors.apellidos = 'Apellidos incorrectos';
      missingDataFunction(true);
    }
    if (values.tipoDocumento === '-1') {
      errors.tipoDocumento = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.documento) {
      errors.documento = 'Obligatorio';
      missingDataFunction(true);
    } else if (values.tipoDocumento === '0' && !validarDNI(values.documento)) {
      errors.documento = 'Formato incorrecto';
      missingDataFunction(true);
    } else if (values.tipoDocumento === '1' && !validarNIE(values.documento)) {
      errors.documento = 'Formato incorrecto';
      missingDataFunction(true);
    } else if (values.tipoDocumento === '3' && !validarCIF(values.documento)) {
      errors.documento = 'Formato incorrecto';
      missingDataFunction(true);
    }
    if (!values.fechaNacimiento) {
      errors.fechaNacimiento = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.pais || values.pais === ' ') {
      errors.pais = 'Obligatorio';
      missingDataFunction(true);
    }
    if ((!values.provincia || values.provincia === ' ') && values.pais === 'España') {
      errors.provincia = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.municipio && values.pais === 'España') {
      errors.municipio = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.cp && values.pais === 'España') {
      errors.cp = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.domicilio) {
      errors.domicilio = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.paisNacimiento || values.paisNacimiento === ' ') {
      errors.paisNacimiento = 'Obligatorio';
      missingDataFunction(true);
    }
    if (
      (!values.provinciaNacimiento || values.provinciaNacimiento === ' ') &&
      values.paisNacimiento === 'España'
    ) {
      errors.provinciaNacimiento = 'Obligatorio';
      missingDataFunction(true);
    }
    if (values.paisNacimiento === 'España' && !values.municipioNacimiento) {
      errors.municipioNacimiento = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.nacionalidad) {
      errors.nacionalidad = 'Obligatorio';
      missingDataFunction(true);
    }
    if (values.nss && values.nss.toString().length > 0 && values.nss.toString().length !== 12) {
      errors.nss = 'Longitud incorrecta';
      missingDataFunction(true);
    }
    if (values.centro === '') {
      values.centro = formationCenter[0]?.Nombre;
    }
    if (values.centro === '-1') {
      errors.centro = 'Obligatorio';
      missingDataFunction(true);
    }
    if (values.sexo === '0' || values.sexo === 0) {
      errors.sexo = 'Obligatorio';
      missingDataFunction(true);
    }
    if (!values.emailPers) {
      errors.emailPers = 'Obligatorio';
      missingDataFunction(true);
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailPers)) {
      errors.emailPers = 'Email incorrecto';
      missingDataFunction(true);
    }
    if (values.telefono && values.telefono.length > 0 && !/^\s*\d[\d\s-]{5,11}\d\s*$/.test(values.telefono)) {
      errors.telefono = 'Teléfono incorrecto';
      missingDataFunction(true);
    }
    if (values.movil && values.movil.length > 0 && !/^\s*\d[\d\s-]{5,11}\d\s*$/.test(values.movil)) {
      errors.movil = 'Móvil incorrecto';
      missingDataFunction(true);
    }
    return errors;
  };

  const saveData = useCallback(
    async (values, withModal = true) => {
      const empresa = getItem(STORAGE_KEYS.STUDENT)?.empresaId;
      const lastUpdate = new Date();
      let isUpdated = 0;
      try {
        const data = await alumnosApiService.comprobarActualizacion({
          empresaId: empresa,
          alumno: datosPersonales.id,
          date: lastUpdate,
        });
        isUpdated = data;
        if (isUpdated === 0) {
          setIsModalShown(true);
        } else {
          const urlToGo = `${config.REACT_APP_NODE_API}actualizarUsuarioPersonales?empresaId=${empresa}`;
          const rawData = {
            id: values.id,
            nombre: values.nombre,
            apellidos: values.apellidos,
            tipoDocumento: values.tipoDocumento,
            documento: values.documento,
            fechaNacimiento: values.fechaNacimiento,
            pais: values.pais,
            provincia: values.provincia,
            municipio: values.municipio,
            cp: values.cp,
            domicilio: values.domicilio,
            paisNacimiento: values.paisNacimiento,
            provinciaNacimiento: values.provinciaNacimiento,
            municipioNacimiento: values.municipioNacimiento,
            nacionalidad: values.nacionalidad,
            nss: values.nss,
            centro: values.centro,
            sexo: values.sexo,
            emailPers: values.emailPers,
            telefono: values.telefono,
            movil: values.movil,
            conocer: values.conocer,
            dndconocer: values.dndconocer,
            headquarter: empresa,
            idAdditio: values.idAdditio,
            idStripe: values.idStripe,
            lopdSede: values.lopdSede ? 'Consiento' : 'No Consiento',
            lopdComunicaciones: values.lopdComunicaciones ? 'Consiento' : 'No Consiento',
          };
          if (withModal) {
            setRaw(rawData);
            setUrl(urlToGo);
            setIsModalShown2(true);
          } else {
            await httpServiceInstanceNode.post(urlToGo, rawData);
          }
        }
      } catch (error) {
        // No hacer nada específico aquí.
      }
    },
    [datosPersonales?.id],
  );

  const formik = useFormik({
    initialValues: buildInitialValues(datosPersonales),
    validateOnChange: false,
    validate,
    onSubmit: (values) => saveData(values, true),
  });

  useEffect(() => {
    const fetchOptions = async () => {
      const pobl = normalizeMunicipioForApi(datosPersonales.municipio ?? '');
      try {
        const paises = await alumnosApiService.cargarPaises({ empresaId: '1' });
        setCountry(paises);
      } catch (error) {
        setCountry('');
      }
      try {
        const provincias = await alumnosApiService.cargarProvincia({ empresaId: '1' });
        setProvince(provincias);
      } catch (error) {
        setProvince('');
      }
      try {
        const poblaciones = await alumnosApiService.cargarPoblaciones({
          empresaId,
          municipio: pobl,
        });
        setPoblation(poblaciones);
      } catch (error) {
        setPoblation('');
      }
      try {
        const fidelizacionList = await matriculacionApiService.cargarFidelizacion({ empresaId });
        setFidelitationList(fidelizacionList);
      } catch (error) {
        setFidelitationList([]);
      }
      try {
        const cps = await alumnosApiService.cargarCp({ empresaId, municipio: pobl });
        setCP(cps);
      } catch (error) {
        setCP('');
      }
      try {
        const centros = await alumnosApiService.cargarCentrosFormacion({ empresaId });
        setFormationCenter(centros);
      } catch (error) {
        setFormationCenter([]);
      }
      try {
        const documentos = await alumnosApiService.cargarDocumentos({ empresaId });
        setDocument(documentos);
      } catch (error) {
        setDocument('');
      }
    };
    fetchOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (formik.values.pais === ' ' || formik.values.pais !== 'España') {
      formik.setValues((prev) => ({ ...prev, provincia: ' ', municipio: '', cp: '' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.pais]);

  useEffect(() => {
    if (formik.values.paisNacimiento === ' ' || formik.values.paisNacimiento !== 'España') {
      formik.setValues((prev) => ({ ...prev, provinciaNacimiento: ' ', municipioNacimiento: '' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.paisNacimiento]);

  useEffect(() => {
    if (formik.values.tipoDocumento === '-1') {
      formik.setValues((prev) => ({ ...prev, documento: '' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.tipoDocumento]);

  useEffect(() => {
    if (formationCenter.length > 0 && idCedesca > 0 && idCntec > 0) {
      const centerMatch = formationCenter.find((center) => center.Nombre === centro);
      if (centerMatch) {
        formik.setValues((prev) => ({ ...prev, centro: centerMatch.Id }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formationCenter, centro, idCedesca, idCntec]);

  useEffect(() => {
    formik.validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const exec = async () => {
      try {
        if (prevActiveTab === '1') {
          if (formik.dirty) await saveData(formik.values, false);
        } else {
          formik.resetForm({ values: formik.values });
        }
      } catch (error) {
        // No hacer nada específico aquí.
      }
    };
    exec();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevActiveTab]);

  useEffect(() => {
    const selectedProvince = formik.values.provincia;
    const selectedBirthProvince = formik.values.provinciaNacimiento;
    let arrayProvince = [];
    let arrayBirthProvince = [];
    if (selectedProvince && poblation.length > 0) {
      arrayProvince = poblation.filter((objeto) => objeto.provincia === selectedProvince);
      arrayProvince.unshift({ nom_municipi: '', provincia: selectedProvince });
    }
    if (selectedBirthProvince && poblation.length > 0) {
      arrayBirthProvince = poblation.filter((objeto) => objeto.provincia === selectedBirthProvince);
      arrayBirthProvince.unshift({ nom_municipi: '', provincia: selectedBirthProvince });
    }
    setPoblationFiltered(arrayProvince);
    setPoblationBirthFiltered(arrayBirthProvince);
  }, [poblation, formik.values.provincia, formik.values.provinciaNacimiento]);

  useEffect(() => {
    const selectedMunicipality = formik.values.municipio;
    if (selectedMunicipality && cp.length > 0) {
      const arrayFiltrado = cp.filter((objeto) => objeto.nom_municipi === selectedMunicipality);
      arrayFiltrado.unshift({ cp: '', nom_municipi: selectedMunicipality });
      setCPFiltered(arrayFiltrado);
    }
  }, [cp, formik.values.municipio]);

  useEffect(() => {
    setMenorEdad(esAlumnoMenor(formik.values.fechaNacimiento));
  }, [formik.values.fechaNacimiento, setMenorEdad]);

  const handleFechaNacimiento = (value) => {
    formik.setValues({ ...formik.values, fechaNacimiento: value });
    setMenorEdad(esAlumnoMenor(value));
  };

  const handleProvinceChange = (event) => {
    const selectedProvince = event.target.value;
    const arrayFiltrado = poblation.filter((objeto) => objeto.provincia === selectedProvince);
    arrayFiltrado.unshift({ nom_municipi: '', provincia: selectedProvince });
    formik.setValues({
      ...formik.values,
      provincia: selectedProvince,
      municipio: arrayFiltrado[0].nom_municipi,
      cp: '',
    });
    setPoblationFiltered(arrayFiltrado);
  };

  const handlePoblationChange = (event) => {
    const selectedMunicipality = event.target.value;
    const arrayFiltrado = cp.filter((objeto) => objeto.nom_municipi === selectedMunicipality);
    arrayFiltrado.unshift({ cp: '', nom_municipi: selectedMunicipality });
    formik.setValues({
      ...formik.values,
      municipio: selectedMunicipality,
      cp: arrayFiltrado[0].cp,
    });
    setCPFiltered(arrayFiltrado);
  };

  const handleBirthProvinceChange = (event) => {
    const selectedProvince = event.target.value;
    const arrayFiltrado = poblation.filter((objeto) => objeto.provincia === selectedProvince);
    arrayFiltrado.unshift({ nom_municipi: '', provincia: selectedProvince });
    formik.setValues({
      ...formik.values,
      provinciaNacimiento: selectedProvince,
      municipioNacimiento: arrayFiltrado[0].nom_municipi,
    });
    setPoblationBirthFiltered(arrayFiltrado);
  };

  const handleEmail = () => {
    const empresa = getItem(STORAGE_KEYS.STUDENT)?.empresaId;
    const urlToGo = `${config.REACT_APP_NODE_API}enviarMailCredenciales?empresaId=${empresa}`;
    const rawData = { id: formik.values.id, emailO: formik.values.emailPers };
    setRaw(rawData);
    setUrl(urlToGo);
    setIsModalShown3(true);
  };

  return {
    formik,
    userOU,
    idCedesca,
    idCntec,
    document,
    country,
    province,
    poblationFiltered,
    poblationBirthFiltered,
    cpFiltered,
    formationCenter,
    fidelitationList,
    isModalShown,
    isModalShown2,
    isModalShown3,
    raw,
    url,
    setIsModalShown2,
    setIsModalShown3,
    tooltipOpen,
    toggleTooltip,
    handleFechaNacimiento,
    handleProvinceChange,
    handlePoblationChange,
    handleBirthProvinceChange,
    handleEmail,
  };
};

export default useDatosPersonales;
